<template>
    <div >
      <reporte-principal />
    <div class="reporte-container">
    <reporte-sexo />
    <reporte-peso />

   
    </div>
    <div>
      <reporte-desnutricion />
      <reporte-vacuna />
      <reporte-usuario />
    </div>
  
  </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { BASE_URL } from '../store/config';
 
  
  export default {
    data() {
      return {
        niños: [],
        errorLoadingNiños: null,
        options: {
        },
      };
    },
    computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
},
    methods: {
      loadNiños() {
        axios
          .get(`${BASE_URL}/api/nino`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          })
          .then(response => {
            this.niños = response.data;
            this.actualizarGrafico();
          })
          .catch(error => {
            this.errorLoadingNiños = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
            console.error('Error al cargar niños:', error);
          });
      },
      actualizarGrafico() {
        // Contar niños por género
        const countMale = this.niños.filter(niño => niño.sexo === 'MASCULINO').length;
        const countFemale = this.niños.filter(niño => niño.sexo === 'FEMENINO').length;
        
       this.options = {
        colors: ["#36A2EB", "#FF6384"],
     
        series: [countMale, countFemale],
         labels: ['MASCULINO', 'FEMENINO']
            }

       
      },
    },
    mounted() {
      this.loadNiños();
    },
  };
  </script>
  
  <style scoped>
  .reporte-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr); /* Divide el contenedor en dos columnas iguales */
    gap: 10px; /* Espacio entre las columnas */
  }

 

  /* Estilos adicionales si es necesario */
  </style>